var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSuccess = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10.017 3.221a9 9 0 0 1 5.646.558.818.818 0 0 1-.666 1.495 7.364 7.364 0 1 0 4.367 6.73v-.752a.818.818 0 0 1 1.636 0v.753l-.007.363a9 9 0 1 1-10.976-9.147m9.586 1.66a.818.818 0 1 1 1.157 1.157l-8.181 8.19a.82.82 0 0 1-1.157 0l-2.455-2.455a.818.818 0 0 1 1.157-1.157L12 12.491z"
})));
export default SvgSuccess;